/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
// tslint:disable:no-magic-numbers
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, ElementRef, EventEmitter, Input, NgZone, Output, TemplateRef, ViewChild, } from '@angular/core';
import { isNotNil, stopEvent, wrapInObservable } from '@gh/core-util';
import { catchError$, delay$, filter$, first$, map$, switchAll$, switchMap$, tap$ } from '@gh/rx/operators';
import { assign, clamp, eq, find, isEmpty, isNil, isString, map, property } from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { AutocompleteOptionDirective } from './autocomplete-option.directive';
import { Option } from './autocomplete-option.model';
import { BOTTOM_PLACEHOLDER_PADDING_BOTTOM, BOTTOM_PLACEHOLDER_PADDING_TOP, DEFAULT_CARD_OFFSET, DEFAULT_MAX_VISIBLE_OPTIONS, DEFAULT_NEXT_BATCH_DISTANCE_PX, DEFAULT_NEXT_BATCH_SIZE, OPTION_HEIGHT, PANEL_MIN_WIDTH, PLACEHOLDER_PADDING_HORIZONTAL, TOP_PLACEHOLDER_PADDING_BOTTOM, TOP_PLACEHOLDER_PADDING_TOP, } from './autocomplete.constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/material/card";
import * as i3 from "../../../common/directives/infinite-scroll.directive";
import * as i4 from "@angular/material/list";
import * as i5 from "../../../common/directives/automation-id.directive";
import * as i6 from "@angular/material/progress-bar";
import * as i7 from "../../../common/pipes/sanitize.pipe";
import * as i8 from "../../../common/pipes/highlight.pipe";
import * as i9 from "../../../../core-mls/translation/translate.pipe";
var _c0 = ["optionContainer"];
function AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r10 = i0.ɵɵnextContext();
    var i_r7 = ctx_r10.index;
    var option_r6 = ctx_r10.$implicit;
    var ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("focus", ctx_r8.focusedIndex === i_r7);
    i0.ɵɵproperty("title", option_r6.display);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r6.display);
} }
var _c1 = function (a0, a1) { return { $implicit: a0, value: a1 }; };
function AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 21);
} if (rf & 2) {
    var option_r6 = i0.ɵɵnextContext(2).$implicit;
    var ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r11.optionTemplate == null ? null : ctx_r11.optionTemplate.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1, option_r6.source, option_r6.value));
} }
function AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
    i0.ɵɵpipe(1, "sanitizeHtml");
    i0.ɵɵpipe(2, "highlight");
} if (rf & 2) {
    var option_r6 = i0.ɵɵnextContext(2).$implicit;
    var ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, option_r6.display, ctx_r12.inputBuffer)), i0.ɵɵsanitizeHtml);
} }
function AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_Template(rf, ctx) { if (rf & 1) {
    var _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-item", 17);
    i0.ɵɵlistener("click", function AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_Template_mat_list_item_click_0_listener($event) { i0.ɵɵrestoreView(_r16); var i_r7 = i0.ɵɵnextContext().index; var ctx_r15 = i0.ɵɵnextContext(3); return ctx_r15.selectOption($event, i_r7); });
    i0.ɵɵelementContainerStart(1, 18);
    i0.ɵɵtemplate(2, AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_ng_container_2_Template, 1, 5, "ng-container", 19);
    i0.ɵɵtemplate(3, AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_div_3_Template, 3, 6, "div", 20);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r18 = i0.ɵɵnextContext();
    var i_r7 = ctx_r18.index;
    var option_r6 = ctx_r18.$implicit;
    var ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("focus", ctx_r9.focusedIndex === i_r7);
    i0.ɵɵpropertyInterpolate1("automation-id", "autocomplete-item:", i_r7, "");
    i0.ɵɵproperty("title", option_r6.display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r9.hasOptionTemplate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", true);
} }
function AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_1_Template, 3, 4, "mat-list-item", 13);
    i0.ɵɵtemplate(2, AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_mat_list_item_2_Template, 4, 6, "mat-list-item", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var option_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r6.group);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !option_r6.group);
} }
function AutocompleteComponent_ng_template_0_mat_card_0_mat_list_item_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item");
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "... ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lbl_no_results"));
} }
var _c2 = function (a0, a1, a2, a3, a4) { return { "width.px": a0, "padding-top.px": a1, "padding-bottom.px": a2, "marginTop.px": a3, "marginBottom.px": a4 }; };
function AutocompleteComponent_ng_template_0_mat_card_0_Template(rf, ctx) { if (rf & 1) {
    var _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-card", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelement(2, "div", 4);
    i0.ɵɵelement(3, "div", 5);
    i0.ɵɵelement(4, "div", 6);
    i0.ɵɵelement(5, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8, 9);
    i0.ɵɵlistener("ghInfiniteScroll", function AutocompleteComponent_ng_template_0_mat_card_0_Template_div_ghInfiniteScroll_6_listener() { i0.ɵɵrestoreView(_r20); var ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.onScroll(); });
    i0.ɵɵelementStart(8, "mat-list", 10);
    i0.ɵɵtemplate(9, AutocompleteComponent_ng_template_0_mat_card_0_ng_container_9_Template, 3, 2, "ng-container", 11);
    i0.ɵɵtemplate(10, AutocompleteComponent_ng_template_0_mat_card_0_mat_list_item_10_Template, 5, 3, "mat-list-item", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("m-placeholder-on-top", ctx_r1.isPlaceholderOnTop)("m-placeholder-on-bottom", !ctx_r1.isPlaceholderOnTop);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction5(22, _c2, ctx_r1.width, ctx_r1.topPlaceholderHeight, ctx_r1.bottomPlaceholderHeight, 0 - ctx_r1.topOffset, 0 - ctx_r1.bottomOffset));
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", ctx_r1.topPlaceholderHeight || ctx_r1.bottomPlaceholderHeight, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", ctx_r1.placeholderTopPadding, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r1.placeholderLeftPadding, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r1.placeholderRightPadding, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", ctx_r1.placeholderBottomPadding, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", ctx_r1.containerHeight, "px");
    i0.ɵɵproperty("loadDistance", ctx_r1.nextBatchDistance);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("height", ctx_r1.listHeight, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.displayNoResults);
} }
var _c3 = function (a0, a1, a2, a3) { return { "width.px": a0, "padding-left.px": a1, "padding-right.px": a2, "margin-bottom.px": a3 }; };
function AutocompleteComponent_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "mat-progress-bar", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("m-placeholder-on-top", ctx_r2.isPlaceholderOnTop)("m-placeholder-on-bottom", !ctx_r2.isPlaceholderOnTop);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction4(5, _c3, ctx_r2.width, ctx_r2.placeholderLeftPadding, ctx_r2.placeholderRightPadding, ctx_r2.progressBarBottomOffset));
} }
function AutocompleteComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AutocompleteComponent_ng_template_0_mat_card_0_Template, 11, 28, "mat-card", 0);
    i0.ɵɵtemplate(1, AutocompleteComponent_ng_template_0_div_1_Template, 2, 10, "div", 1);
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.displayMenu);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isLoadingMore);
} }
/**
 * TODO: host Component parameter
 * TODO: NOT ACTUAL(we have no scroll then) bug with 2 options (without scroll),
 * TODO: NOT ACTUAL Test real data request
 * TODO: Cancel request on blur
 * FIXME: scroll top when autocomplete loaded variants
 * FIXME: DO NOT send request if empty buffer
 * TODO: replace function (anyList: any[]) => {
 *      this.updateOptions(anyList);
 *      assign(this.listSourceParams, { loading: false });
 *    } to WITHOUT side effects function
 */
var AutocompleteComponent = /** @class */ (function () {
    function AutocompleteComponent(changeDetectorRef, ngZone) {
        this.changeDetectorRef = changeDetectorRef;
        this.ngZone = ngZone;
        this.inputBuffer = '';
        // onChangeCallback: (_: any) => void = noop;
        this.activeCardWidth = void 0;
        // @DANGEROUS: check initial active width
        this.activeWidth = void 0;
        this.minWidth = PANEL_MIN_WIDTH;
        this.nextBatchSize = DEFAULT_NEXT_BATCH_SIZE;
        this.nextBatchDistance = DEFAULT_NEXT_BATCH_DISTANCE_PX;
        this.debounceTime = 500;
        this.maxVisibleOptions = DEFAULT_MAX_VISIBLE_OPTIONS;
        this.hasChips = false;
        // tslint:disable-next-line:no-output-named-after-standard-event
        this.change = new EventEmitter();
        // tslint:disable-next-line:no-output-named-after-standard-event
        this.select = new EventEmitter();
        this.loadMore = new EventEmitter();
        this.suggestionListHasChanged = new Subject();
        this.selectedOptionChange = new Subject();
        this.focusedIndex = 0;
        this.opened = false;
        this.loadFilter$$ = new Subject();
        this.currentValue = void 0;
        this.options = [];
        // private autocompleteInput: AutocompleteDirective;
        this.initialized$$ = new BehaviorSubject(false);
        this.isLoading = false;
        this.endOfLastLoadedRange = 0;
        this.reachEndOfList = false;
        this.suggestions = [];
        this.anchorDimensions = { width: 0, height: 0 };
        this.placeholderPosition = 'top';
        this._textKey = property('text');
    }
    Object.defineProperty(AutocompleteComponent.prototype, "textKey", {
        set: function (textKey) {
            this._textKey = isString(textKey) ? property(textKey) : textKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "displayKey", {
        set: function (displayKey) {
            this._displayKey = isString(displayKey) ? property(displayKey) : displayKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "valueKey", {
        set: function (valueKey) {
            this._valueKey = isString(valueKey) ? property(valueKey) : valueKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "noResults", {
        get: function () {
            return this.suggestions.length === 0 && this.reachEndOfList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "isLoadingMore", {
        get: function () {
            return this.isLoading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "value", {
        get: function () {
            return this.currentValue;
        },
        set: function (value) {
            this.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "displayFoundItems", {
        get: function () {
            var _a = this, opened = _a.opened, options = _a.options;
            // selectedOption ==> inputBuffer exists
            return opened && !isEmpty(options);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "displayMenu", {
        get: function () {
            return this.displayFoundItems || this.displayNoResults;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "displayNoResults", {
        /**
         * Display "no results" panel only in bound mode
         */
        get: function () {
            return this.noResults && !this._unbound;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "width", {
        // get unbound(): boolean {
        //   return this.autocompleteInput.unbound;
        // }
        get: function () {
            return Math.max(this.anchorDimensions.width + PLACEHOLDER_PADDING_HORIZONTAL * 2, this.minWidth);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "anchorWidth", {
        get: function () {
            return this.anchorDimensions.width + PLACEHOLDER_PADDING_HORIZONTAL * 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "topOffset", {
        get: function () {
            return this.isPlaceholderOnTop ? this.anchorDimensions.height + TOP_PLACEHOLDER_PADDING_TOP : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "topPlaceholderHeight", {
        get: function () {
            return this.isPlaceholderOnTop
                ? this.anchorDimensions.height + TOP_PLACEHOLDER_PADDING_TOP + TOP_PLACEHOLDER_PADDING_BOTTOM
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "bottomOffset", {
        get: function () {
            return this.isPlaceholderOnTop ? 0 : this.anchorDimensions.height + BOTTOM_PLACEHOLDER_PADDING_BOTTOM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "bottomPlaceholderHeight", {
        get: function () {
            return this.isPlaceholderOnTop
                ? 0
                : this.anchorDimensions.height + BOTTOM_PLACEHOLDER_PADDING_TOP + BOTTOM_PLACEHOLDER_PADDING_BOTTOM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "placeholderTopPadding", {
        get: function () {
            return this.isPlaceholderOnTop ? TOP_PLACEHOLDER_PADDING_TOP : BOTTOM_PLACEHOLDER_PADDING_TOP;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "placeholderBottomPadding", {
        get: function () {
            // return PLACEHOLDER_PADDING_BOTTOM + 5;
            return this.isPlaceholderOnTop ? TOP_PLACEHOLDER_PADDING_BOTTOM : BOTTOM_PLACEHOLDER_PADDING_BOTTOM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "placeholderLeftPadding", {
        get: function () {
            return PLACEHOLDER_PADDING_HORIZONTAL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "placeholderRightPadding", {
        get: function () {
            return this.width - this.anchorWidth + PLACEHOLDER_PADDING_HORIZONTAL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "progressBarBottomOffset", {
        get: function () {
            return this.isPlaceholderOnTop ? 0 : -this.anchorDimensions.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "hasOptionTemplate", {
        get: function () {
            return isNotNil(this.optionTemplate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "isPlaceholderOnTop", {
        get: function () {
            return this.placeholderPosition === 'top';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "containerHeight", {
        get: function () {
            return Math.min(this.options.length, this.maxVisibleOptions) * OPTION_HEIGHT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutocompleteComponent.prototype, "listHeight", {
        get: function () {
            return this.options.length * OPTION_HEIGHT;
        },
        enumerable: true,
        configurable: true
    });
    AutocompleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Loading filter autocomplete
        this.loadFilter$$.pipe(tap$(function () {
            _this.isLoading = true;
        }), switchAll$(), catchError$(function () { return [[]]; }), tap$(function (anyList) {
            var _a = _this, endOfLastLoadedRange = _a.endOfLastLoadedRange, nextBatchSize = _a.nextBatchSize;
            var suggestions = _this.suggestions.concat(anyList);
            _this.isLoading = false;
            _this.endOfLastLoadedRange = endOfLastLoadedRange + nextBatchSize;
            _this.suggestions = suggestions;
            _this.updateOptions(_this.suggestions);
            _this.changeDetectorRef.markForCheck();
        }), switchMap$(function () { return _this.ngZone.onMicrotaskEmpty.pipe(first$()); }))
            .subscribe(function () {
            _this.suggestionListHasChanged.next();
        });
    };
    AutocompleteComponent.prototype.setUnbound = function (unbound) {
        this._unbound = unbound;
    };
    AutocompleteComponent.prototype.setAnchorDimensions = function (width, height) {
        this.anchorDimensions = { width: width, height: height };
    };
    AutocompleteComponent.prototype.typingResults = function (value) {
        assign(this, { inputBuffer: value, suggestions: [], endOfLastLoadedRange: 0 });
        this.loadNextSuggestions();
        this.currentValue = void 0;
        this.changeDetectorRef.markForCheck();
    };
    AutocompleteComponent.prototype.ngAfterContentInit = function () {
        this.initialized$$.next(true);
    };
    /**
     * Clears selected suggestion
     */
    AutocompleteComponent.prototype.resetTo = function (value) {
        var option = isNil(value) ? void 0 : this.createOption(value);
        var inputBuffer = option ? option.text : '';
        var optionValue = option ? option.value : void 0;
        assign(this, {
            selectedOption: void 0,
            currentValue: void 0,
            focusedIndex: 0,
            suggestions: [],
            opened: false,
        });
        this.resetSearch(inputBuffer);
        this.updateOptions([]);
        this.change.emit(optionValue);
        this.select.emit(optionValue);
        this.changeDetectorRef.markForCheck();
    };
    AutocompleteComponent.prototype.open = function () {
        var activeWidth = this.activeWidth;
        assign(this, {
            opened: true,
            focusedIndex: 0,
            // Sometimes we need change input width according to UI (e.g. long data)
            activeCardWidth: activeWidth ? (activeWidth + DEFAULT_CARD_OFFSET * 2) : void 0,
            suggestions: [],
            endOfLastLoadedRange: 0,
            reachEndOfList: false,
        });
        this.loadNextSuggestions();
        this.changeDetectorRef.markForCheck();
    };
    AutocompleteComponent.prototype.close = function () {
        var selectedOption = this.getVirtualSelectedOption();
        assign(this, {
            opened: false,
            options: [],
            inputBuffer: selectedOption && selectedOption.text || '',
        });
        this.changeDetectorRef.markForCheck();
    };
    // FIXME: if no activeCard width -> add paddings to card
    AutocompleteComponent.prototype.controlWidth = function () {
        var _a = this, activeCardWidth = _a.activeCardWidth, activeWidth = _a.activeWidth, displayMenu = _a.displayMenu;
        return (displayMenu && activeCardWidth && activeCardWidth - DEFAULT_CARD_OFFSET * 2 + "px") || '100%';
    };
    AutocompleteComponent.prototype.moveFocus = function (shift) {
        var _a = this, focusedIndex = _a.focusedIndex, options = _a.options;
        var targetIndex = clamp(focusedIndex + shift, 0, options.length - 1);
        this.focusedIndex = targetIndex;
        this.ensureOptionVisible(targetIndex);
        this.changeDetectorRef.markForCheck();
    };
    AutocompleteComponent.prototype.selectByIndex = function (index) {
        var options = this.options;
        var selectedOption = options[index];
        if (selectedOption && !selectedOption.group) {
            var text = selectedOption.text, value = selectedOption.value;
            assign(this, {
                selectedOption: selectedOption,
                inputBuffer: text,
                currentValue: value,
            });
            this.selectedOptionChange.next(selectedOption);
            this.change.emit(value);
            this.select.emit(value);
            this.close(); // ???
            this.changeDetectorRef.markForCheck();
        }
    };
    AutocompleteComponent.prototype.setPlaceholderPosition = function (position) {
        var _this = this;
        this.placeholderPosition = position;
        Promise.resolve().then(function () { return _this.changeDetectorRef.markForCheck(); });
    };
    AutocompleteComponent.prototype.onScroll = function () {
        var _a = this, isLoading = _a.isLoading, reachEndOfList = _a.reachEndOfList;
        if (!isLoading && !reachEndOfList && !this.noResults) {
            this.loadNextSuggestions();
        }
    };
    AutocompleteComponent.prototype.setValue = function (nextValue) {
        var _this = this;
        return this.initialized$$.pipe(
        // set value only after autocomplete component is initialized
        // this method can be called from AutocompleteDirective.writeValue when AutocompleteComponent is not initialized
        filter$(Boolean), 
        // we use delay(0) to avoid ExpressionChangedAfterItHasBeenCheckedError
        delay$(0), map$(function () {
            if (_this._unbound) {
                _this.setUnboundValue(nextValue);
            }
            else {
                _this.setBoundValue(nextValue);
            }
            _this.changeDetectorRef.markForCheck();
            return _this.getVirtualSelectedOption();
        }));
    };
    /**
     * Returns selected option for bound mode, or virtual selected option for unbound mode.
     * There is no actual selected option in unbound mode.
     */
    AutocompleteComponent.prototype.getVirtualSelectedOption = function () {
        return this._unbound ? Option.createText(this.inputBuffer) : this.selectedOption;
    };
    AutocompleteComponent.prototype.setUnboundValue = function (text) {
        var inputBuffer = this.inputBuffer;
        if (text !== inputBuffer) {
            assign(this, {
                selectedOption: void 0,
                inputBuffer: text,
                currentValue: void 0,
            });
            if (this.initialized$$.value) {
                this.change.emit(text);
            }
        }
    };
    AutocompleteComponent.prototype.setBoundValue = function (nextValue) {
        var _a = this, currentValue = _a.currentValue, options = _a.options;
        if (nextValue !== currentValue) {
            var equalsByValueKey = function (_a) {
                var value = _a.value;
                return eq(value, nextValue);
            };
            // if value is set before options loaded, then create single option for current value.
            var optionFromList = find(options, equalsByValueKey);
            var nextOptionSource = optionFromList || nextValue;
            var selectedOption = this.createOption(nextOptionSource);
            if (!optionFromList) {
                var text = selectedOption.text, value = selectedOption.value;
                assign(this, {
                    selectedOption: selectedOption,
                    inputBuffer: text,
                    currentValue: value,
                });
            }
            else {
                assign(this, {
                    inputBuffer: selectedOption.text,
                    currentValue: nextValue,
                    selectedOption: selectedOption,
                });
            }
            if (this.initialized$$.value) {
                this.change.emit(nextValue);
            }
        }
    };
    /**
     * Updates scroll of suggestion menu
     * // FIXME: Short distance reduces nextBatchDistance luft. When data is big we have narrow bottom
     * // TODO: Create controlled component which will control scroll. AutocompleteScroll/InfiniteScroll Directive
     * @TODO PLANNING: replace keys controls to next sprint
     */
    AutocompleteComponent.prototype.ensureOptionVisible = function (index) {
        var optionContainerEl = this.optionContainer.nativeElement;
        var focusedTop = index * OPTION_HEIGHT;
        var scrollTop = optionContainerEl.scrollTop, clientHeight = optionContainerEl.clientHeight;
        if (focusedTop + OPTION_HEIGHT > scrollTop + clientHeight) {
            // scroll down
            optionContainerEl.scrollTop = focusedTop - clientHeight + OPTION_HEIGHT;
        }
        else if (focusedTop < scrollTop) {
            // scroll up
            optionContainerEl.scrollTop = focusedTop;
        }
    };
    /**
     * selectOption option
     * @param event
     * @param index of selected item
     */
    AutocompleteComponent.prototype.selectOption = function (event, index) {
        stopEvent(event);
        this.selectByIndex(index);
    };
    /**
     * Update suggestions
     * @param suggestions
     */
    AutocompleteComponent.prototype.updateOptions = function (suggestions) {
        var _this = this;
        var endOfLastLoadedRange = this.endOfLastLoadedRange;
        this.options = map(suggestions, function (suggestion) { return _this.createOption(suggestion); });
        this.reachEndOfList = suggestions.length < endOfLastLoadedRange;
    };
    AutocompleteComponent.prototype.loadNextSuggestions = function () {
        var _this = this;
        var _a = this, nextBatchSize = _a.nextBatchSize, endOfLastLoadedRange = _a.endOfLastLoadedRange;
        this.loadMore.emit({
            query: { from: endOfLastLoadedRange, to: endOfLastLoadedRange + nextBatchSize, filter: this.inputBuffer },
            load: function (ob) { return _this.loadFilter$$.next(wrapInObservable(ob)); },
        });
    };
    AutocompleteComponent.prototype.resetSearch = function (inputBuffer) {
        this.inputBuffer = inputBuffer;
        this.suggestions = [];
        this.endOfLastLoadedRange = 0;
        this.reachEndOfList = false;
    };
    AutocompleteComponent.prototype.createOption = function (suggestion) {
        var _a = this, _textKey = _a._textKey, _displayKey = _a._displayKey, _valueKey = _a._valueKey, grouped = _a.grouped;
        return Option.create(suggestion, _textKey, _displayKey, _valueKey, grouped);
    };
    AutocompleteComponent.ɵfac = function AutocompleteComponent_Factory(t) { return new (t || AutocompleteComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    AutocompleteComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AutocompleteComponent, selectors: [["gh-autocomplete"]], contentQueries: function AutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, AutocompleteOptionDirective, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionTemplate = _t.first);
        } }, viewQuery: function AutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(TemplateRef, true);
            i0.ɵɵviewQuery(_c0, true, ElementRef);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionContainer = _t.first);
        } }, hostAttrs: ["role", "autocomplete"], hostVars: 2, hostBindings: function AutocompleteComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("gh-autocomplete", true);
        } }, inputs: { activeWidth: "activeWidth", minWidth: "minWidth", nextBatchSize: "nextBatchSize", nextBatchDistance: "nextBatchDistance", debounceTime: "debounceTime", maxVisibleOptions: "maxVisibleOptions", hasChips: "hasChips", panelClass: "panelClass", grouped: "grouped", textKey: ["optionTextKey", "textKey"], displayKey: ["optionDisplayKey", "displayKey"], valueKey: ["optionValueKey", "valueKey"], value: "value" }, outputs: { change: "change", select: "select", loadMore: "loadMore" }, exportAs: ["ghAutocomplete"], decls: 1, vars: 0, consts: [["class", "gh-autocomplete-card", 3, "ngStyle", "m-placeholder-on-top", "m-placeholder-on-bottom", 4, "ngIf"], ["class", "gh-autocomplete-progress-bar", 3, "m-placeholder-on-top", "m-placeholder-on-bottom", "ngStyle", 4, "ngIf"], [1, "gh-autocomplete-card", 3, "ngStyle"], [1, "placeholder-container"], [1, "placeholder-top"], [1, "placeholder-left"], [1, "placeholder-right"], [1, "placeholder-bottom"], [1, "m-menu-container", 3, "loadDistance", "ghInfiniteScroll"], ["optionContainer", ""], [1, "gh-autocomplete-menu"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "gh-option-group", 3, "title", "focus", 4, "ngIf"], ["class", "gh-option", "tabindex", "0", 3, "title", "focus", "automation-id", "click", 4, "ngIf"], [1, "gh-option-group", 3, "title"], [1, "gh-text"], ["tabindex", "0", 1, "gh-option", 3, "title", "automation-id", "click"], [3, "ngSwitch"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngSwitchCase"], ["class", "gh-text", 3, "innerHtml", 4, "ngSwitchDefault"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "gh-text", 3, "innerHtml"], [1, "gh-text-no-results"], [1, "gh-autocomplete-progress-bar", 3, "ngStyle"], ["mode", "indeterminate"]], template: function AutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, AutocompleteComponent_ng_template_0_Template, 2, 2, "ng-template");
        } }, directives: [i1.NgIf, i2.MatCard, i1.NgStyle, i3.InfiniteScrollDirective, i4.MatList, i1.NgForOf, i4.MatListItem, i5.AutomationIDDirective, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, i1.NgTemplateOutlet, i6.MatProgressBar], pipes: [i7.SanitizeHtmlPipe, i8.HighlightPipe, i9.TranslatePipe], styles: [".autocomplete-overlay-box {\n  height: auto !important; }\n\n  .autocomplete-input-element.mat-input-element {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: calc(100% - 20px); }\n\n  .autocomplete-overlay-panel {\n  display: block; }\n\n.gh-autocomplete-input-container[_ngcontent-%COMP%] {\n  z-index: 30;\n  width: 100%; }\n\n.m-menu-container[_ngcontent-%COMP%] {\n  min-height: 60px;\n  z-index: 10;\n  overflow-x: hidden;\n  overflow-y: auto;\n  pointer-events: auto; }\n\n.gh-autocomplete-menu[_ngcontent-%COMP%] {\n  position: relative;\n  flex-direction: column;\n  padding-top: 0; }\n  .gh-autocomplete-menu[_ngcontent-%COMP%]   .gh-option[_ngcontent-%COMP%] {\n    padding: 0 6px;\n    white-space: nowrap;\n    cursor: pointer; }\n  .gh-autocomplete-menu[_ngcontent-%COMP%]   .gh-text[_ngcontent-%COMP%] {\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .gh-autocomplete-menu[_ngcontent-%COMP%]   .gh-option-group[_ngcontent-%COMP%] {\n    padding: 0 6px;\n    white-space: nowrap; }\n    .gh-autocomplete-menu[_ngcontent-%COMP%]   .gh-option-group[_ngcontent-%COMP%]   .gh-text[_ngcontent-%COMP%] {\n      position: relative;\n      left: -10px;\n      font-weight: bold; }\n\n.mat-form-field[_ngcontent-%COMP%] {\n  width: 100%; }\n  .mat-form-field.suggestions-container[_ngcontent-%COMP%] {\n    width: calc(100% - 40px);\n    top: -30px;\n    padding-left: 20px;\n    padding-right: 20px; }\n  .mat-form-field[_ngcontent-%COMP%]     .mat-input-infix {\n    width: 100%; }\n\n.gh-autocomplete-progress-bar[_ngcontent-%COMP%] {\n  position: absolute;\n  overflow: hidden;\n  z-index: 999;\n  width: 100%; }\n  .gh-autocomplete-progress-bar.with-icon[_ngcontent-%COMP%] {\n    width: calc(100% + 20px);\n    left: -20px;\n    top: 7px; }\n  .gh-autocomplete-progress-bar.m-placeholder-on-top[_ngcontent-%COMP%] {\n    top: -17px; }\n  .gh-autocomplete-progress-bar.m-placeholder-on-bottom[_ngcontent-%COMP%] {\n    bottom: 12px; }\n\n.gh-autocomplete-card[_ngcontent-%COMP%] {\n  overflow: hidden;\n  background: transparent;\n  padding: 0;\n  pointer-events: none; }\n  .gh-autocomplete-card.with-icon[_ngcontent-%COMP%] {\n    right: 40px;\n    width: calc(100% + 60px); }\n\n.gh-autocomplete-active[_ngcontent-%COMP%] {\n  z-index: 10010 !important;\n  color: red;\n  font-weight: bold; }\n\n.placeholder-container[_ngcontent-%COMP%] {\n  position: absolute;\n  left: 0;\n  right: 0; }\n  .m-placeholder-on-top[_ngcontent-%COMP%]   .placeholder-container[_ngcontent-%COMP%] {\n    top: 0; }\n  .m-placeholder-on-bottom[_ngcontent-%COMP%]   .placeholder-container[_ngcontent-%COMP%] {\n    bottom: 0; }\n\n.placeholder-top[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  width: 100%; }\n\n.placeholder-left[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%; }\n\n.placeholder-right[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%; }\n\n.placeholder-bottom[_ngcontent-%COMP%] {\n  position: absolute;\n  bottom: 0;\n  width: 100%; }"], changeDetection: 0 });
    return AutocompleteComponent;
}());
export { AutocompleteComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'gh-autocomplete',
                templateUrl: 'autocomplete.component.html',
                styleUrls: ['autocomplete.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                // tslint:disable-next-line:use-host-property-decorator
                host: {
                    'role': 'autocomplete',
                    '[class.gh-autocomplete]': 'true',
                },
                exportAs: 'ghAutocomplete',
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.NgZone }]; }, { activeWidth: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], nextBatchSize: [{
            type: Input
        }], nextBatchDistance: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], maxVisibleOptions: [{
            type: Input
        }], hasChips: [{
            type: Input
        }], panelClass: [{
            type: Input,
            args: ['panelClass']
        }], grouped: [{
            type: Input
        }], change: [{
            type: Output
        }], select: [{
            type: Output
        }], loadMore: [{
            type: Output
        }], template: [{
            type: ViewChild,
            args: [TemplateRef, { static: false }]
        }], optionContainer: [{
            type: ViewChild,
            args: ['optionContainer', { read: ElementRef, static: false }]
        }], optionTemplate: [{
            type: ContentChild,
            args: [AutocompleteOptionDirective, { static: false }]
        }], textKey: [{
            type: Input,
            args: ['optionTextKey']
        }], displayKey: [{
            type: Input,
            args: ['optionDisplayKey']
        }], valueKey: [{
            type: Input,
            args: ['optionValueKey']
        }], value: [{
            type: Input
        }] }); })();
